<app-content>
  <app-breadcrumbs>
    <li>
      Płatności online
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Płatności online
    </h2>
    <form novalidate [formGroup]='form' (ngSubmit)='onSubmit()' *ngIf='!loading()'>
      <div class='row' *ngIf='shipment() as shipment'>
        <div class='col-12'>
          <app-label label='Rodzaj sprawy:'>
            {{ form.serviceName.value }}
          </app-label>
        </div>
        <div class='col-12'>
          <app-label label='Tytuł płatności:'>
            {{ form.paymentTitle.value }}
          </app-label>
        </div>
      </div>
      <br>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"payer" as controlName'>
            <label [for]='controlName'>
              Płatnik *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option [value]='item' *ngFor='let item of payers'>
                {{ item?.name || (item?.firstName + ' ' + item?.lastName) }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class='d-flex justify-content-end'>
        <app-label
          label='Wysokośc opłaty:'>{{ form.totalAmount.value || '0,00' | currency }}
        </app-label>
      </div>
      <hr>
      <br>
      <div class='form-actions'>
        <a [routerLink]='goBackPath'
           class='btn btn-secondary'>
          Anuluj
        </a>
        <button type='submit' class='btn btn-primary'>
          Dokonaj płatności
        </button>
      </div>
    </form>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
